export default (base = '', langs, langCode = 'ar') => {
  if (!langs) return base;
  switch (langCode) {
    case 'en':
      return base;
    case 'ar': {
      if (langs.arabic_ar) return langs.arabic_ar;
      return base;
    }
    case 'es': {
      if (langs.espanol_es) return langs.espanol_es;
      return base;
    }
    default: {
      if (langs.arabic_ar) return langs.arabic_ar;
      return base;
    }
  }
};
